<template>
	<el-container >
		<el-header class="title" >
			<el-row type="flex" align="middle">
				<el-col :span="22" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item >用户管理</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
				<el-col :span="2">
					<el-button class="el-button--primary vam" size="small" @click="popAddUserPanel()">
						<i class="el-icon-plus">添加</i>
					</el-button>
					<!--<el-button class="el-button&#45;&#45;primary vam" size="mini" @click="query(1,99)"><i class="el-icon-plus">刷新</i></el-button>-->
				</el-col>
			</el-row>
		</el-header>
		<el-main>
			<el-table size="medium" :data="tableData" header-cell-class-name="table_header" :stripe="true" :height="tableHeight">
				<el-table-column prop="displayName" label="姓名" >
				</el-table-column>
				<el-table-column prop="phone" label="手机号码">
				</el-table-column>
				<el-table-column prop="email" label="Email">
				</el-table-column>
				<el-table-column prop="type" label="角色" :formatter="roleFormatter">
				</el-table-column>
				<el-table-column prop="status" label="状态" :formatter="statusFormatter">
				</el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-button
							size="mini"
							class="el-button--primary" icon="el-icon-edit" circle @click.native.prevent="popEditUserPanel(scope.row)"></el-button>
						<el-button
							size="mini"
							class="el-button--danger" icon="el-icon-delete" circle @click.native.prevent="deleteUser(scope.row)"></el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-main>
		<el-dialog title="添加用户" :visible.sync="showAddUserPanel">
			<add-user-panel @addsuccess="addUserSuccess"></add-user-panel>
		</el-dialog>
		<el-dialog title="修改用户信息" :visible.sync="showEditUserPanel">
			<edit-user-panel :user="editUser" @updatesuccess="updateUserSuccess"></edit-user-panel>
		</el-dialog>
	</el-container>
</template>

<script>
	import AddUserPanel from  "./AddUserPanel.vue";
	import EditUserPanel from "./EditUserPanel.vue";
	import config from "../../../config/global.js";
	import axios from "axios"

	var getUserListUrl = config.host+"/backend/user/getuserall.json";
	var deleteUserUrl = config.host + "/backend/user/deleteuser.json";

    export default {
      name: "user-query",
			components:{AddUserPanel,EditUserPanel},
			data:function () {
				return {
					tableData: [],
					total:0,
					pageSize:50,
					currentPageIndex:1,
					tableHeight:window.innerHeight-120+"px",
					showAddUserPanel:false,
					showEditUserPanel:false,
					editUser:{},
					loading:false
				}
			},
			mounted:function () {
				this.queryUsers();
			},
			methods:{
				currentPageChangeHandler:function (val) {
					this.currentPageIndex = val;
					this.queryUsers();
				},
				queryUsers:function () {
					if(this.loading == false ){
						this.loading = true;
						this.$http.post(getUserListUrl,{}).then(
							function(response){
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								var res = response.body;
								if(res.result==1){
									this.tableData = res.items;
								}else{
									this.$message.error(res.emsg);
								}
								this.loading=false;
							},function(){
								this.$message.error("获取用户列表失败");
								this.loading=false;
							})
					}
				},
				popAddUserPanel:function () {
					this.showAddUserPanel = true;
				},
				addUserSuccess:function () {
					this.showAddUserPanel = false;
					this.queryUsers();
				},
				updateUserSuccess:function () {
					this.showEditUserPanel = false;
					this.queryUsers();
				},
				popEditUserPanel:function (item) {
					var user = JSON.parse(JSON.stringify(item));
					this.editUser = user;
					this.showEditUserPanel = true;
				},
				deleteUser:function (item) {
					this.$confirm('您确定要删除该用户吗？', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning',
					}).then(()=>{
						axios({
							method: 'post',
							url:deleteUserUrl,
							data:{id:item.id}
						}).then((response)=>{
							var defaultResult = this.responseDefaultHandle(response);
							if(defaultResult == false )
								return;
							this.$message({
								message: '用户已成功删除',
								type: 'success'
							});
							this.queryUsers();
						})
							.catch((error)=>{
								this.$message.error("删除用户失败");
							})
					});
				},
				statusFormatter:function (item) {
					if(item.status == 0 ){
						return "未激活";
					}else if(item.status == 1){
						return "已激活";
					}else{
						return "";
					}
				},
				roleFormatter:function (item) {
					if(item.type == 1){
						return "管理员";
					}else{
						return "";
					}
				}
			}
    }
</script>

<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/user/UserQuery.vue